<template>
    <div v-if="services.group || services.rooms" class="row border-radius bg-white padding-flex mb-1">
        <div class="col-md-12 estate-service">

            <div class="row bg-white radius marginTop25 descriptionContent services">
                <div class="col-sm-12 descriptionTextCont">
                    <h2>
                        <masked-image class="icon_title" src="/img/icons/features.svg" />
                        {{ trans('labels.other_char') | capitalize }}
                    </h2>
                    <div class="mt-1">

                        <div v-if="services.group" class="marginTop15">
                            <div
                                v-for="(service, index) in services.group" 
                                :key="index" 
                                class="tag"
                            >
                                <tooltip>
                                    <template v-slot:outer>
                                        {{ service['nome-macro'] }}
                                        <img v-if="service.option" src="/img/icons/service-note.svg" width="15">
                                    </template>
                                    <template v-if="service.option" v-slot:inner>
                                        <template v-if="service['nome-micro']">
                                            <strong>{{ trans('labels.features') | capitalize }}:</strong>
                                            <ul>
                                                <li v-for="nameMicro in service['nome-micro']">
                                                    {{ nameMicro }}
                                                </li>
                                            </ul>
                                        </template>
                                        <template v-if="service['nome-descrizione']">
                                            <strong>{{ trans('labels.description') | capitalize }}:</strong><br/>
                                            {{ service['nome-descrizione'] }}
                                        </template>
                                    </template>
                                </tooltip>
                            </div>
                        </div>

                        <div v-if="services.rooms" class="mt-1">
                            <template v-if="services.group">
                                <strong>{{ trans('labels.desc_locals') | capitalize }}:</strong><br/>
                            </template>
                            <div
                                v-for="(service, index) in services.rooms" 
                                :key="index" 
                                class="tag"
                            >
                                <tooltip>
                                    <template v-slot:outer>
                                        {{ service['nome-categoria'] }} {{ service['nome-macro'] }}
                                        <img v-if="service.option" src="/img/icons/service-note.svg" width="15" />
                                    </template>

                                    <template v-if="service['nome-micro'] || service['nome-descrizione']" v-slot:inner>
                                        <template v-if="service['nome-micro']">
                                            <strong>{{ trans('labels.features') | capitalize }}:</strong>
                                            <ul>
                                                <li v-for="nameMicro in service['nome-micro']">
                                                    {{ nameMicro }}
                                                </li>
                                            </ul>
                                        </template>
                                        <template v-if="service['nome-descrizione']">
                                            <strong>{{ trans('labels.description') | capitalize }}:</strong><br/>
                                            {{ service['nome-descrizione'] }}
                                        </template>
                                    </template>
                                </tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Tooltip from '../SlottedTooltip'

export default {
    components: {
        'tooltip': Tooltip,
    },

    props: {
        services: {
            type: [Array, Object],
            required: true,
        },
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },
    },

}
</script>